// This file uses JSX syntax for Vue components
import { h } from 'vue';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Button } from 'ant-design-vue';
import { RouterLink } from 'vue-router';

export function isMonthTargeted(targets, monthIndex) {
  return targets.some(target => target.month === monthIndex);
}

export function formatNumber(val) {
  if (!val) return '';
  if (isNaN(val)) return val;
  if (val < 0) return '(' + Math.abs(val).toFixed(2) + ')';
  return Number(val).toFixed(2); // "1234.57"
}

export function targetValue(target) {
  const numberFormat = new Intl.NumberFormat('id');

  if (target.target_waktu) {
    return target.target_waktu;
  }
  if (target.target_manual) {
    return target.target_manual;
  }
  if (target.target_nominal) {
    return target.target_nominal_max
      ? numberFormat.format(target.target_nominal) + '-' + numberFormat.format(target.target_nominal_max)
      : formatNumber(target.target_nominal);
  }
  return '';
}

export function getItemFlags(data, profile, filters, checkPermission, handleDeleteKpi) {
  const isEditable = data.editable;
  const isEpi = profile.jenis_perusahaan != 'anak';
  const isCreateKpi = checkPermission('create kpi korporat') && isEditable && isEpi && data.is_parent;
  const isUpdateKpi = checkPermission('update kpi korporat') && isEditable && isEpi;
  const isDeleteKpi = checkPermission('delete kpi korporat') && isEditable && isEpi;

  const deleteButton = h(Button, {
    shape: 'circle',
    icon: h(DeleteOutlined),
    size: 'small',
    style: 'background-color: transparent; border: none; color: #555',
    onClick: () => handleDeleteKpi(data.id_kpi, data.name),
  });

  const updateButton = !data.is_parent
    ? h(
        RouterLink,
        {
          to: `/nko-kontrak-edit-kpi/${data.id_kpi}/1/${filters.tahun}`,
        },
        {
          default: () =>
            h(Button, {
              shape: 'circle',
              icon: h(EditOutlined),
              size: 'small',
              style: 'background-color: transparent; border: none; color: #555',
            }),
        },
      )
    : h(
        RouterLink,
        {
          to: `/nko-kontrak-edit/${data.id_kpi}/1/${filters.tahun}`,
        },
        {
          default: () =>
            h(Button, {
              shape: 'circle',
              icon: h(EditOutlined),
              size: 'small',
              style: 'background-color: transparent; border: none; color: #555',
            }),
        },
      );

  const addButton = h(
    RouterLink,
    {
      to: `/nko-kontrak-add-kpi/${data.id_kpi}/1/${filters.tahun}/${filters.entitas}`,
    },
    {
      default: () =>
        h(Button, {
          shape: 'circle',
          icon: h(PlusOutlined),
          size: 'small',
          style: 'background-color: transparent; border: none; color: #555',
        }),
    },
  );

  const create = isCreateKpi ? addButton : null;
  const update = isUpdateKpi ? updateButton : null;
  const del = isDeleteKpi ? deleteButton : null;
  return {
    create,
    update,
    del,
  };
}
